import { LucideIcon } from 'lucide-react'

export const ViewField = ({
  label,
  value,
  icon: Icon,
}: {
  label?: string
  value?: string
  icon?: LucideIcon
}) => {
  return (
    <div className="relative bg-primary-white rounded-2xl px-4 pt-1 pb-4">
      <p className="text-text-disabled text-sm">{label}</p>
      <p>{value}</p>
      {Icon && (
        <div className="absolute right-4 top-1/2 -translate-y-1/2">
          <Icon size={24} />
        </div>
      )}
    </div>
  )
}
